import React, {useState} from 'react';
import moment from 'jalali-moment';
import {CalenderWrapper} from '@mazraeapp/react-time-calender-kit';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
const CardToCardDateBS = ({
  isOpen,
  setIsOpen,
  addDateHandler,
}: CardToCardBottomSheetProps) => {
  const m = moment();
  const [selectedDate, setSelectedDate] = useState<ISelectedDate>({
    days: m.locale('fa').format('DD'),
    month: m.locale('fa').format('MM'),
    year: m.locale('fa').format('YYYY'),
  });

  const changeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedDate(prev => {
      return {
        ...prev,
        [event.target.name]: event.target.value,
      };
    });
  };
  return (
    <BottomSheet
      onDismiss={() => {
        setIsOpen(false);
      }}
      open={isOpen}
      blocking={true}
      className="custom-bottom-sheet"
    >
      <div className="flex w-full flex-col CalenderWrapperBottomSheet-wrapper p-6 gap-5 relative">
        <SpanIcon
          className="icon-nameClose-remove absolute top-6 left-6 text-2xl text-gray-500"
          onClick={() => setIsOpen(false)}
        />
        <p className="p-0 m-0 w-full flex justify-center text-gray-950 text-lg font-Regular mb-6">
          تاریخ کارت به کارت
        </p>
        <div className="flex w-full justify-between px-3 ">
          <CalenderWrapper
            startYear={moment().add(2, 'jYear').jYear()}
            buttonClassName="border-[1px] text-md w-[95px] rounded-[8px] gap-3 px-1 h-[40px] flex text-gray-500"
            buttonGroupClassName="w-full buttonGroup-wrapper flex justify-between items-center"
            days={selectedDate.days}
            month={selectedDate.month}
            year={selectedDate.year}
            calenderType="jalali"
            onChangeCalender={changeHandler}
            buttonWrapperClassName="min-w-[90px]"
            yearDuration={5}
          />
        </div>
        <div className="flex w-full justify-between items-center px-3">
          <div className="flex w-full justify-end">
            <button
              className="text-green-500 border-none outline-none bg-white flex items-center gap-2"
              onClick={() => {
                addDateHandler(
                  `${selectedDate.year}-${selectedDate.month}-${selectedDate.days}`,
                );
                setIsOpen(false);
              }}
            >
              تایید
            </button>
          </div>
        </div>
      </div>
    </BottomSheet>
  );
};

export default CardToCardDateBS;
